import { render, staticRenderFns } from "./Technology.vue?vue&type=template&id=7008587e&scoped=true"
import script from "./Technology.vue?vue&type=script&lang=js"
export * from "./Technology.vue?vue&type=script&lang=js"
import style0 from "./Technology.vue?vue&type=style&index=0&id=7008587e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7008587e",
  null
  
)

export default component.exports